/** One retry for transient discovery failures; never repeat an authentication denial. */
export function retryInstrumentSearch(
  failureCount: number,
  error: unknown,
): boolean {
  const status = (error as { response?: { status?: number } } | null)?.response
    ?.status;
  return (
    failureCount < 1 &&
    (status == null || status === 408 || status === 429 || status >= 500)
  );
}
